import { configs } from '@hero/configs';
import { NAVIGATION_APP_URLS } from '@hero/constants';

function getName({ firstName, lastName } = {}) {
  const normalize = val => (val && typeof val === 'string' && val.trim()) || null;

  const first = normalize(firstName);
  const last = normalize(lastName);

  if (!first && !last) return '-';
  return `${first || ''} ${last || ''}`;
}

const getArrayChunks = (initialArray, size) =>
  Array.from(new Array(Math.ceil(initialArray?.length / size)), (_, i) =>
    initialArray.slice(i * size, i * size + size)
  );

function bootstrap() {
  const prefetchUrl1 = getNavigationLink('b2b');

  const prefetchLink1 = document.createElement('link');
  prefetchLink1.rel = 'prefetch';
  prefetchLink1.href = prefetchUrl1;
  document.head.appendChild(prefetchLink1);

  const prefetchUrl2 = getNavigationLink('bulkGifting');

  const prefetchLink2 = document.createElement('link');
  prefetchLink2.rel = 'prefetch';
  prefetchLink2.href = prefetchUrl2;
  document.head.appendChild(prefetchLink2);
}

function getNavigationLink(appName) {
  const env = configs.isProduction ? 'production' : 'uat';
  return NAVIGATION_APP_URLS?.[appName]?.[env];
}

export { bootstrap, getArrayChunks, getName, getNavigationLink };
